<template>
  <div class="page-header min-height-200" style="margin-right: -24px; margin-left: -34%;">
  </div>
  <div class="row m-5">
    <div class="col-md-2">
      <button class="btn btn-danger" @click="migration('all');">전체DB이관(사용X)</button>
    </div>

    <div class="col-md-2">
      <button class="btn btn-secondary" @click="migration('customer');">고객정보이관(사용X,customer)</button>
    </div>

    <div class="col-md-2">
      <button class="btn btn-onmaum" @click="migration('customer_d');">고객정보이관(치과)</button>
    </div>

    <div class="col-md-2">
      <button class="btn btn-onmaum" @click="migration('customer_f');">고객정보이관(지문)</button>
    </div>

    <div class="col-md-2">
      <button class="btn btn-primary" @click="migration('planner');">플래너정보이관</button>
    </div>

    <div class="col-md-2">
      <button class="btn btn-secondary" @click="migration('account');">계정정보이관</button>
    </div>

    <div class="col-md-2">
      <button class="btn btn-info" @click="migration('itsm');">개선요청정보이관</button>
    </div>

    <div class="col-md-2">
      <button class="btn btn-warning" @click="migration('index');">인덱스이관</button>
    </div>

    <div class="col-md-2">
      <button class="btn btn-primary" @click="migration('hondi_adopt');">혼디도랑 입양현황 이관</button>
    </div>
    
  </div>

  <div class="row m-5">
    <div class="col-md-2">
      <button class="btn btn-primary" @click="reset('MenuAndHospital');">메뉴,병원 인덱스</button>
    </div>

    <div class="col-md-2">
    </div>

    <div class="col-md-2">
    </div>
    
    <div class="col-md-2">
      
    </div>

    <div class="col-md-2">
    </div>

    <div class="col-md-2">
      
    </div>
    
  </div>

  <div class="row m-5">
    <div class="col-2">
      <button class="btn btn-primary" @click="clickConfirm('관리자 서비스 시작', 'adminStart');">관리자 서비스 시작</button>
    </div>
    <div class="col-2">
      <!-- <button class="btn btn-danger" @click="clickConfirm('관리자 서비스 중지', 'adminStop');">관리자 서비스 중지</button> -->
    </div>
    <div class="col-2">
      <button class="btn btn-onmaum" @click="clickConfirm('관리자 서비스 재시작', 'adminRestart');">관리자 서비스 재시작</button>
    </div>
    <div class="col-2">
      <button class="btn btn-primary" @click="clickConfirm('혼디도랑 서비스 시작', 'serverStart');">혼디도랑 서비스 시작</button>
    </div>
    <div class="col-2">
      <button class="btn btn-danger" @click="clickConfirm('혼디도랑 서비스 중지', 'serverStop');">혼디도랑 서비스 중지</button>
    </div>
    <div class="col-2">
      <button class="btn btn-onmaum" @click="clickConfirm('혼디도랑 서비스 재시작', 'serverRestart');">혼디도랑 서비스 재시작</button>
    </div>
  </div>

  <div class="row m-5">
    <div class="col-2">
      <button class="btn btn-danger" @click="migration('delProd');">(개발에서만사용)운영DB삭제</button>
    </div>
    <div class="col-2">
      <button class="btn btn-danger" @click="migration('setProd');">(개발에서만사용)개발DB => 운영DB</button>
    </div>
    <div class="col-2">
    </div>
    <div class="col-2">
    </div>
    <div class="col-2">
    </div>
    <div class="col-2">
    </div>
  </div>

</template>

<script>
export default {
    name: 'DevTools',
    methods: {
      migration(data){
        this.$store.dispatch('migration', data);
      },

      reset(data) {
        this.$store.dispatch('reset', data);
      },

      serverManage(data) {
        this.$store.dispatch('serverManage', data);
      },

      clickConfirm(text, data) {
        if(confirm(`'${text}'를 정말로 실행하시겠습니까?`)){
          this.serverManage(data);
        }
      },

      // toggleNoticeModal(){
      //   this.$store.dispatch('toggleNoticeModal')
      // }
    },
}
</script>

<style>

</style>